import * as React from 'react'

import { observer } from 'mobx-react'

import { IGeoJson2DGeographicCoordinates } from '~/client/graph'
import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import Delivery from '~/client/src/shared/models/Delivery'

import DeliveryWorkflowCard from '../ExpandableWorkflowCard/components/DeliveryWorkflowCard'
import GeneralMapPopup, { MapPopupBody } from './GeneralMapPopup'

const noActiveDeliveries = 'No active deliveries'
interface IProps {
  item: MapViewItemBase
  onClose: () => void
  activeDeliveryId: string
  relatedDeliveries: Delivery[]
  onFilterResetClick: () => void
  onDeliveryClick: (deliveryId: string) => void
  // Anchors the popup to the delivery pin rather than the raw location, and clears
  // the pin's art — mirrors FormMapPopup so both pin types read the same.
  coordOverride?: IGeoJson2DGeographicCoordinates
  offset?: number
}

@observer
export default class DeliveryMapPopup extends React.Component<IProps> {
  public static defaultProps = {
    relatedDeliveries: [],
  }

  public render() {
    const { item, onClose, relatedDeliveries, coordOverride, offset } =
      this.props

    return (
      <GeneralMapPopup
        item={item}
        coordOverride={coordOverride}
        offset={offset}
        onClose={onClose}
      >
        <MapPopupBody>
          {relatedDeliveries?.length ? (
            relatedDeliveries.map(delivery => {
              return (
                <DeliveryWorkflowCard
                  key={delivery.id}
                  className="tw:h-full!"
                  delivery={delivery}
                  onClick={this.onDeliveryClick}
                />
              )
            })
          ) : (
            <div className="tw:p-2.5 tw:text-muted-foreground">
              {noActiveDeliveries}
            </div>
          )}
        </MapPopupBody>
      </GeneralMapPopup>
    )
  }

  private onDeliveryClick = (delivery: Delivery): void => {
    this.props.onDeliveryClick(delivery.id)
  }
}
